import { useContext, useEffect, useState } from "react";
import { flushSync } from "react-dom";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import * as _div_ from "@Elementos/Div";
import * as _txta_ from "@Elementos/TextArea";
import * as _lul_ from "@Utilitarios/Listados/ListaUL";
import * as _preconf_ from "@Utilitarios/PreConfirmacion/PreConfirmacion";
import * as _posconf_ from "@Utilitarios/PostConfirmacion/PostConfirmacion";
import * as _procAcc_ from "@Utilitarios/ProcesandoAccion/ProcesandoAccion";
import VisorPDF from "@Utilitarios/VisorPDF/VisorPDF";

import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";

import MAgregarProducto from "@GenerarPedidoProduccion/Modales/MAgregarProducto";

import * as _testing_ from "@Funciones/testing";
import "./MDetallePedidoProduccion.css";

function MDetallePedidoProduccion({
  origenComponente,
  registro = {},
  datosComplementarios,
  columnaEvento,
  parametros,
  tipoEvento,
  fCerrarComponente,
  fEstablecerVariablesTabla,
  fActualizarTablaTotal,
}) {
  const { ecv_u, cv_u, rolUsuarioSesion, esComputadora } = useContext(Contexto);
  const [recargaComponente, erecargaComponente] = useState(false);

  const [v_c, ev_c] = useState({
    //MODAL
    modal_titulo: "",
    modal_mostrar: false,
    modal_mensaje: "",
    modal_estilos: {},
    //PRE-CONFIRMAR
    preConfirmar_mostrar: false,
    preConfirmar_funcion: () => {},
    preConfirmar_funcion_parametros: {},
    //PROCESANDO ACCION
    procesandoAccion_mostrar: false,
    //POST-CONFIRMAR
    postConfirmar_mostrar: false,
    postConfirmar_funcion: () => {},
    postConfirmar_function_parametros: {},
    //ERRORES
    errores_mostrar: false,
    errores_lista: [],
  });
  const [v_u, ev_u] = useState({
    //TABLA
    do_datosTabla: {},
    do_filtros: [],
    do_filtrosActualizados: {},
    da_grid: [],
    da_headgrid: [],
    d_multiselecion: false,
    do_seleccionados: {},
    d_editarSolicitud: false,
    d_editarProduccion: false,
    d_pdf: "",
    d_esperandoProcesoTabla: false,

    d_verPdf: false,
    d_fecEntrega: _f_.fechaActual({
      formato: "yyyy-mm-dd",
    }),
    d_pedidoEntregado: "",
    d_comentarioPedido: parametros?.comentario,
    d_pdfPedido: "",
    d_totalTerminado: 0,
    d_estado: -1,
  });
  useEffect(() => {
    // console.log("entre a pedido detallesdfasdfasdf");
    // fCerrarComponentePadre?.();
    console.log(origenComponente, registro, parametros, tipoEvento, columnaEvento);
    console.log(registro?.pedidos?.[columnaEvento]?.codPedido);

    const detallePedidoAPI = _api_.f_estructuraDetalleProduccion({
      parametros: {
        produccion: registro?.pedidos?.[columnaEvento]?.codPedido ?? 0,
        editarEntrega: v_u.d_editarProduccion,
        editarPedido: v_u.d_editarSolicitud,
        todo: "N",
      },
      timeout: 20000,
      origen: origenComponente,
    });
    detallePedidoAPI.respuesta.then((dPC) => {
      _f_.asignar(ecv_u, dPC, true, origenComponente);
      console.log(dPC);
      if (!dPC.error) {
        _f_.asignar(ev_u, {
          do_datosTabla: dPC.contenido,
          do_filtros: dPC.contenido.filtros,
          da_grid: dPC.contenido.grid,
          da_headgrid: dPC.contenido.headgrid,
          d_multiselecion: dPC.contenido.multiseleccion,
          d_totalTerminado: dPC.contenido.total_terminado,
          d_estado: dPC.contenido?.estado,
          // d_pdfPedido: dPC.contenido.documento.pdf,
          // d_pagoEnYape: dPC.contenido.pagoYape,
          // d_pagoEnEfectivo: dPC.contenido.pagoEfectivo,
          // d_pedidoEntregado: dPC.contenido.entregado,
        });
      }
    });
  }, [recargaComponente, v_u.d_editarProduccion, v_u.d_editarSolicitud]);

  // useEffect(() => {
  //   console.log(v_u.do_filtrosActualizados);
  // }, [v_u.do_filtrosActualizados]);

  return (
    <>
      {v_c.modal_mostrar && (
        <ModalInformacion
          titulo={v_c.modal_titulo}
          estilos={v_c.modal_estilos}
          fCerrar={() => {
            _f_.asignar(ev_c, {
              modal_mostrar: false,
              preConfirmar_mostrar: false,
              procesandoAccion_mostrar: false,
              postConfirmar_mostrar: false,
            });
            _f_.asignar(ev_u, { d_verPdf: false });
          }}>
          {/* {v_c.errores_mostrar && <_lul_.ListaUL texto={"Errores"} listaElementos={v_c.errores_lista} />}
          {v_u.d_verPdf && (
            <VisorPDF
              id="mi-pdf"
              titulo="PDF"
              base64={v_u.d_pdfPedido}
              nombreArchivo={`PedidoProduccion_${registro?.codPedido ?? 0}_${_f_.fechaActual({ formato: "dd_mm_yyyy" })}_${_f_.horaActual({ formato: "hh_mm_ss" })}.pdf`}
              autoDownload={false}
              modoImpresion={esComputadora ? "sistema" : "ventana"}
            />
          )} */}
          <MAgregarProducto
            origenComponente={origenComponente}
            fCerrarComponente={() => {
              _f_.asignar(ev_c, {
                modal_mostrar: false,
                preConfirmar_mostrar: false,
                procesandoAccion_mostrar: false,
                postConfirmar_mostrar: false,
              });
              _f_.asignar(ev_u, { d_verPdf: false });
            }}
            fActualizarTablaTotal={(evento) => {
              erecargaComponente((prev) => !prev);
            }}
            registro={{
              codPedido: registro?.pedidos?.[columnaEvento]?.codPedido ?? 0,
              categoria: `Cod. Pedido Nro. ${String(registro?.pedidos?.[columnaEvento]?.codPedido ?? "0000").padStart(8, "0")}`,
            }}
          />
        </ModalInformacion>
      )}
      <div className={"MDetallePedidoProduccionCSS-contenedor"}>
        <div className={"titulo-componente"}>{`${registro?.Maestros ?? "ningun solicitante"}`}</div>
        <div className={"MDetallePedidoProduccionCSS-cabecera"}>
          <div className={"MDetallePedidoProduccionCSS-c-nroPedido"}>
            <_div_.Div2
              estilos={{ fuenteDiv2: "1.2rem" }}
              texto={`Nro. ${String(registro?.pedidos?.[columnaEvento]?.codPedido ?? "0000").padStart(8, "0")}`}
            />
          </div>
        </div>

        <div className={"MDetallePedidoProduccionCSS-tabla"}>
          <_tabla_.Tabla
            origenComponente={origenComponente}
            modoVista={"modo2"}
            datosComplementarios={{ codPedido: registro?.pedidos?.[columnaEvento]?.codPedido ?? 0 }}
            cabecera={v_u.da_headgrid}
            registros={v_u.da_grid}
            filtros={v_u.do_filtrosActualizados}
            permiteMultiseleccion={v_u.d_multiselecion}
            permiteOpciones={true}
            camposCodigosSeleccion={["codigo"]}
            fObtenerSeleccionados={(seleccionados) => {
              _f_.asignar(ev_u, { do_seleccionados: seleccionados });
            }}
            // mapaDeComponentes={{
            //   MAgregarPersona,
            // }}
            fNotificarActualizacionDeTabla={(actualizar) => {
              if (actualizar) {
                erecargaComponente((prev) => !prev);
              }
            }}
            fObtenerDatosParcialesActualizados={(datos) => {
              console.log(datos);
              _f_.asignar(ev_u, { d_totalTerminado: datos?.TotalEntrega });
            }}
            fObtenerEstadoProcesando={(estado) => {
              // console.log("esta procesando la tabla:",estado)
              _f_.asignar(ev_u, { d_esperandoProcesoTabla: estado });
            }}
          />
        </div>
        <div className={"MDetallePedidoProduccionCSS-comentario"}>
          <_txta_.TextArea
            onBlur={(evento) => {
              // console.log(evento.target.value)
              _f_.asignar(ev_u, { d_comentarioPedido: evento.target.value });
            }}
            texto="ingrese un comentario"
            defaultValue={v_u.d_comentarioPedido}
            estilos={{ anchoTA: "100%", altoTA: "100%" }}
          />
        </div>

        <div className={"MDetallePedidoProduccionCSS-opciones"}>
          <div className={"MDetallePedidoProduccionCSS-pagos"}>
            <_div_.Div2
              estilos={{ fuenteDiv2: "1rem" }}
              texto={`TOTAL: ${_f_.formatearValor({ valor: v_u.d_totalTerminado, tipo: "moneda", moneda: "PEN", precision: "2" })}`}
            />
          </div>

          {!v_u.d_editarSolicitud && !v_u.d_editarProduccion && (
            <></>
            // <_btn_.Boton
            //   disabled={v_u.d_esperandoProcesoTabla}
            //   texto="PDF"
            //   tipo="btn-2"
            //   estilos={{ anchoB2: "3rem", color: "#af3232" }}
            //   onClick={() => {
            //        _f_.asignar(ev_c, {
            //         modal_mostrar: true,
            //         modal_titulo: "Comprobante",
            //         modal_estilos: { altoMI: "30rem", anchoMI: "30rem" },
            //       });
            //       _f_.asignar(ev_u, { d_verPdf: true });

            //   }}
            // />
          )}
          {v_u.d_editarSolicitud && (
            <_btn_.Boton
              disabled={v_u.d_esperandoProcesoTabla}
              texto="Agregar Producto"
              tipo="btn-2"
              estilos={{ anchoB2: "8rem", color: "var(--color_verde_1)" }}
              onClick={() => {
                // erecargaComponente((prev) => !prev);
                _f_.asignar(ev_c, {
                  modal_mostrar: true,
                  modal_titulo: "Agregar Producto a Pedido",
                  modal_estilos: { anchoMI: "30rem", altoMI: "initial" },
                });
              }}
            />
          )}
          {(v_u.d_editarProduccion || v_u.d_editarSolicitud) && (
            <_btn_.Boton
              disabled={v_u.d_esperandoProcesoTabla}
              texto="Finalizar Edición"
              tipo="btn-2"
              estilos={{ anchoB2: "8rem", color: "var(--color_amarillo_1)", colorFuenteB2: "black" }}
              onClick={() => {
                // erecargaComponente((prev) => !prev);
                _f_.asignar(ev_u, {
                  d_editarSolicitud: false,
                  d_editarProduccion: false,
                });
              }}
            />
          )}

          {!v_u.d_editarSolicitud && !v_u.d_editarProduccion && (
            <_btn_.Boton
              disabled={v_u.d_esperandoProcesoTabla}
              texto="Editar Solicitud"
              tipo="btn-2"
              estilos={{ anchoB2: "8rem", color: "var(--color_amarillo_1)", colorFuenteB2: "black" }}
              onClick={() => {
                // erecargaComponente((prev) => !prev);
                _f_.asignar(ev_u, {
                  d_editarSolicitud: true,
                });
              }}
            />
          )}

          {!v_u.d_editarSolicitud &&
            !v_u.d_editarProduccion &&
            v_u.d_estado == 2 &&
            ["SADM01"].includes(rolUsuarioSesion) && (
              <_btn_.Boton
                texto="Editar Produccion"
                tipo="btn-2"
                estilos={{ anchoB2: "8rem", color: "var(--color_verde_1)" }}
                onClick={() => {
                  // erecargaComponente((prev) => !prev);

                  _f_.asignar(ev_u, {
                    d_editarProduccion: true,
                  });
                }}
              />
            )}
          {!v_u.d_editarSolicitud && v_u.d_estado == 1 && (
            <_btn_.Boton
              disabled={v_u.d_esperandoProcesoTabla}
              texto="Finalizar Producción"
              tipo="btn-2"
              estilos={{ anchoB2: "8rem", color: "var(--color_verde_1)" }}
              onClick={() => {
                // erecargaComponente((prev) => !prev);
                // _f_.asignar(ev_u, {
                //   d_editarSolicitud: true,
                // });
                const llamarAPI = _api_.f_guardarIngresoProductoMaestro({
                  parametros: {
                    produccion: registro?.pedidos?.[columnaEvento]?.codPedido ?? 0,
                    fecProduccion: null,
                    funcion: 2,
                  },
                  origen: origenComponente,
                  timeout: 2000,
                });
                llamarAPI.respuesta.then((dPC) => {
                  _f_.asignar(ecv_u, dPC, true, origenComponente);
                  console.log(dPC);
                  if (!dPC.error) {
                    fCerrarComponente?.()
                    fActualizarTablaTotal?.(true)
                  }
                });
              }}
            />
          )}
        </div>
      </div>
    </>
  );
}
export default MDetallePedidoProduccion;
